// extracted by mini-css-extract-plugin
export default {"item":"-cYtGXah","morer":"HRSsusy5"};